import { z } from 'zod';
import { zMetricNumericType, zMetricType } from '../core';
import { RecordTypes } from '@strength/db-schema';
export const MetricsLibraryModule = 'MetricsLibrary';
const module = z.literal(MetricsLibraryModule);
export const zMetricConfig = z.object({
    numericType: zMetricNumericType,
    allowRange: z.boolean(),
    units: z.array(z.string()),
    keywords: z.array(z.string()),
    // Optional so existing metric create/update callers that predate the field
    // parse without change; support sets it via the admin UI (phase 7).
    // `metricConfigDefaults` normalizes absence to `false` on read.
    isInverseScale: z.boolean().optional(),
    // Optional (backward-compatible): marks a metric as prescription-enabled so
    // `%` can be prescribed against a KPI benchmark. Set via the admin UI.
    // `metricConfigDefaults` normalizes absence to `false` on read.
    isPercent: z.boolean().optional(),
});
const BaseMetricSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    type: zMetricType,
    isCollectable: z.boolean(),
    sortOrder: z.number(),
    config: zMetricConfig,
});
export const MetricFormSchema = BaseMetricSchema.omit({ id: true });
export const SearchMetrics = z.object({
    module,
    type: z.literal('SearchMetrics'),
    input: z.object({
        types: z.array(zMetricType).optional(),
        limit: z.number().positive().optional(),
        offset: z.number().optional(),
    }),
});
export const zRecordType = z.enum(RecordTypes);
export const CreateMetricSchema = z.object({
    orgId: z.uuid(),
    name: z.string().min(1),
    type: zMetricType,
    sortOrder: z.number(),
    isCollectable: z.boolean().default(true),
    isDefault: z.boolean().default(false),
    config: zMetricConfig,
    recordType: zRecordType.nullable().optional(),
    categoryId: z.uuid().nullable().optional(),
});
export const UpdateMetricSchema = z.object({
    orgId: z.uuid(),
    id: z.uuid(),
    name: z.string().min(1).optional(),
    type: zMetricType.optional(),
    sortOrder: z.number().optional(),
    isCollectable: z.boolean().optional(),
    isDefault: z.boolean().optional(),
    config: zMetricConfig.optional(),
    recordType: zRecordType.nullable().optional(),
    categoryId: z.uuid().nullable().optional(),
});
export const UpdateMetricKeywordsSchema = z.object({
    orgId: z.uuid(),
    id: z.uuid(),
    keywords: z.array(z.string().trim().min(1)),
});
//# sourceMappingURL=commands.js.map